import { render, staticRenderFns } from "./carMonitoring.vue?vue&type=template&id=5b207593&scoped=true"
import script from "./carMonitoring.vue?vue&type=script&lang=js"
export * from "./carMonitoring.vue?vue&type=script&lang=js"
import style0 from "./carMonitoring.vue?vue&type=style&index=0&id=5b207593&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b207593",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b207593')) {
      api.createRecord('5b207593', component.options)
    } else {
      api.reload('5b207593', component.options)
    }
    module.hot.accept("./carMonitoring.vue?vue&type=template&id=5b207593&scoped=true", function () {
      api.rerender('5b207593', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/carMonitoring.vue"
export default component.exports